import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import AddCreativeButton from "./AddCreativeButton";
import AdvertiserCredits from "widgets/toolbars/AdvertiserCredits";
import ImportExportButton from "./ImportExportButton";

import {
	Toolbar as RhombusToolbar
} from "rhombus-react";

import { SEARCH_DEBOUNCE, TYPES } from "utils/constants";
import Permissioned from "widgets/Permissioned";
import BulkActions from "widgets/toolbars/BulkActions";
import SelectCount from 'widgets/toolbars/SelectCount';

import "./Toolbar.css";

export default function Toolbar({ searchTerm, handleSearch, isLoading }) {
	let { creatives, currentSelection } = useSelector(state => ({
			creatives: state.creatives.items,
			currentSelection: state.selected.creatives,
		}))
		, isSomethingSelected = (currentSelection.length > 0)
		, hasCreatives = creatives.length > 0
		, addCreativeAllowablePermissions=[
			{
				domain: "Creative View",
				action: "Upload Assets",
			},
			{
				domain: "Creative View",
				action: "Upload VAST",
			},
			{
				domain: "Creative View",
				action: "Upload Ad Files",
			},
		]
		, searchProps = {
			isDisabled: isSomethingSelected,
		};


	if(!searchTerm && !hasCreatives) {
		return null;
	}

	return (
		<RhombusToolbar
			search
			searchProps={searchProps}
			searchDebounce={SEARCH_DEBOUNCE}
			onSearch={handleSearch}
			searchValue={searchTerm}
			className="creative-search"
		>
			<div className="button-side">
				<Permissioned key="add-creative" any={ addCreativeAllowablePermissions } >
					<AddCreativeButton />
				</Permissioned>
				{isSomethingSelected ? <div className="toolbar-divider" /> : null}
				<SelectCount type={TYPES.CREATIVES} />
				<BulkActions type={TYPES.CREATIVES} />
			</div>
			<div className="right-button-side">
				<AdvertiserCredits />
				<ImportExportButton />
			</div>
		</RhombusToolbar>
	);
}

Toolbar.displayName = "CreativesToolbar";
Toolbar.propTypes = {
	handleSearch:PropTypes.func.isRequired,
};
